import React, { Fragment } from "react";
import { ApiResult } from "../../lib/CmsApi";
import MagazinHeader from "./MagazinHeader";
import Pagination from "../common/Pagination";
import Content from "../common/Content";
import EmptyList from "./EmptyList";
import ArticleTeaser from "./MagazineTeaser/ArticleTeaser";
import HeaderWithIntro from "../common/HeaderWithIntro";
import CheckerboardComponent from "../common/CheckerboardComponent";
import CustomPageHead from "../common/CustomPageHead";
import Seo from "../../lib/models/seo";

export interface Props {
  content: ApiResult<"loadMagazinNewsPage">;
  tags: ApiResult<"listTags">;
  news: ApiResult<"listMagazinNews">;
  page: number;
  activeTags: string[];
  seo?: Seo;
}
class NewsPagination extends Pagination<
  ApiResult<"listMagazinNews">["items"][0]
> {}
export default function NewsPage(props: Props) {
  let offset = 0;
  return (
    <Fragment>
      <CustomPageHead
        title={props.content && props.content.name}
        desc={props.content && props.content.intro}
        seo={props.seo}
      />
      <MagazinHeader
        breadCrumpPath={[
          {
            title: props.content.name,
            route: "news"
          }
        ]}
        activeTab="news"
        tags={props.tags}
        activeTags={props.activeTags}
      />
      <main>
        <Content padded bottomMargin>
          <HeaderWithIntro
            headline={props.content.name}
            intro={props.content.intro}
            size={1}
            blue
          />
          <CheckerboardComponent>
            <NewsPagination
              name={props.content.name}
              total={props.news.total}
              items={props.news.items}
              page={props.page}
              renderItem={(item, idx) => {
                if (!item.headerImage) offset++;
                return (
                  <ArticleTeaser
                    {...item}
                    key={item.slug}
                    swap={(idx + offset) % 2 !== 0}
                  />
                );
              }}
              renderEmpty={() => {
                return <EmptyList />;
              }}
            />
          </CheckerboardComponent>
        </Content>
      </main>
    </Fragment>
  );
} // TODO: merge with CheckerboardComponent => PaginatedCheckerboard?

NewsPage.getImages = (props: Props) => {
  const images = props.news.items.map(n => n.headerImage);
  return images;
};
